'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormattedJobTitle({
  companyName,
  jobTitle,
  jobTitleHidden = false
}) {
  if (!companyName && !jobTitle) {
    return null;
  }
  if (!companyName) {
    return jobTitle;
  }
  if (!jobTitle || jobTitleHidden) {
    return companyName;
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "universalSidebar.formatterComponents.FormattedJobTitle.titleAtCompany",
    options: {
      title: jobTitle,
      company: companyName
    }
  });
}
FormattedJobTitle.propTypes = {
  companyName: PropTypes.string,
  jobTitle: PropTypes.string,
  jobTitleHidden: PropTypes.bool
};